import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {SessionsAuthHeader} from './SessionsAuthHeader'

registerReactPartial('sessions-auth-header', {
  Component: SessionsAuthHeader,
})
